//碳积分活动码
export const CARBONPOINT = 'CARBONPOINT';
